import { SchoolI } from "@seneca/schools-service-types";
import {
  FetchQueryOptions,
  WithRequired
} from "@tanstack/query-core/src/types";
import { UseQueryOptions } from "@tanstack/react-query";
import { QueryOptions } from "../../../utils/reactQuery/types";
import { fetchMySchoolInfo } from "./client";

export type SchoolInfoQueryData = SchoolI | undefined;

export const fetchMySchoolInfoQueryOptions =
  (): QueryOptions<SchoolInfoQueryData> => ({
    queryFn: fetchMySchoolInfo,
    queryKey: ["schools", "my-school-info"]
  });
